import React, { FC } from 'react';
import { NewUnitRequiredFormProps } from './NewUnitRequiredFormProps';
import Text from '@ingka/text';
import useTranslation from '../../../hooks/useTranslation';
import ProjectNameInput from '../../ProjectTab/ProjectNameInput';
import ProjectDatesFields from '../../ProjectTab/ProjectDatesFields';
import SiteInfoSelects from '../../SiteTab/SiteInfoFields/SiteInfoSelects';
import LocationInfoCountrySelect from '../../SiteTab/LocationInfoCountrySelect';
import ProjectConfidentialButton from '../../ProjectTab/ProjectConfidentialButton';
import ProjectCountryResponsible from '../../ProjectCountryResponsible';

const NewUnitRequiredForm: FC<NewUnitRequiredFormProps> = ({
  countries,
  isConfidentialAllowed,
  usersList,
  onCountryChanged,
}) => {
  const t = useTranslation();
  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.projectInformation')}
      </Text>
      <ProjectNameInput />
      <ProjectDatesFields openingDate />
      <LocationInfoCountrySelect
        countries={countries}
        onCountryChange={onCountryChanged}
      />
      <SiteInfoSelects unitType transactionType />
      <ProjectCountryResponsible usersList={usersList} required={true} />
      {isConfidentialAllowed && <ProjectConfidentialButton />}
    </>
  );
};

export default NewUnitRequiredForm;
